import {AsyncPipe, NgSwitch, NgSwitchCase} from '@angular/common';
import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HelperPipesModule, MatomoService, RegisterStepsCompletedType} from '@aztrix/helpers';
import {SessionsService} from '@aztrix/sdk';
import {BehaviorSubject, first, map, Subscription} from 'rxjs';

import {ModeService} from '../../services/mode.service';
import {AuthFormHeaderComponent} from '../auth-form-header/auth-form-header.component';
import {VerificationStepComponent} from './verification-step/verification-step.component';
import {VerificationSuccessStepComponent} from './verification-success-step/verification-success-step.component';
import {TranslatePipe} from '@aztrix/translate';

@Component({
  selector: 'ax-verification-form',
  templateUrl: './verification-form.component.html',
  styleUrls: ['./verification-form.component.scss', '../form.scss'],
  standalone: true,
  imports: [
    AsyncPipe,
    AuthFormHeaderComponent,
    NgSwitch,
    NgSwitchCase,
    VerificationStepComponent,
    VerificationSuccessStepComponent,
    TranslatePipe,
  ],
})
export class VerificationFormComponent implements OnInit, OnDestroy {
  @Input() logo = 'custom:aztrixlogo';
  @Output() loginComplete = new EventEmitter<{authToken: string | undefined}>();
  @Output() registerComplete = new EventEmitter();

  step = 0;
  verificationValue: string;

  loading$ = new BehaviorSubject(false);

  verificationValue$ = this._route.queryParams.pipe(
    map((queryParams) => queryParams['verificationValue'])
  );

  private _subscription = new Subscription();

  constructor(
    private _mode: ModeService,
    private _matomo: MatomoService,
    private _sessions: SessionsService,
    private _route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this._matomo.trackEvent('register', RegisterStepsCompletedType.VERIFICATION);

    this._subscription = this.verificationValue$.subscribe((verificationValue) => {
      this.verificationValue = verificationValue;
    });
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
  }

  verificationCompleted() {
    this._mode.setMode('verification', {
      username: this.verificationValue,
    });
    this.step = 1;
    this._matomo.trackEvent('register', RegisterStepsCompletedType.SUCCESS);
    this.registerComplete.emit();
  }

  continue() {
    this.loading$.next(true);
    if (this._mode.password) {
      this._sessions
        .login({login: this.verificationValue, password: this._mode.password}, 'response')
        .pipe(
          first(),
          map((resp) => resp.headers.get('AuthToken')),
          map((authToken) => authToken || undefined)
        )
        .subscribe({
          next: (authToken) => {
            this._mode.mode$.next('login');
            this.loginComplete.emit({authToken});
          },
          error: () => {
            this._mode.setMode('login', {verificationValue: this.verificationValue});
          },
        });
    } else {
      this._mode.setMode('login', {verificationValue: this.verificationValue});
    }
  }
}
